"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WithWindowSizeType = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withWindowSize.js";
function cov_6vtzfnhiq() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withWindowSize.js";
  var hash = "0219a77160bca23d0d481e8be704d55efe0dac1e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/withWindowSize.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 22
        },
        end: {
          line: 4,
          column: 96
        }
      },
      "1": {
        start: {
          line: 4,
          column: 29
        },
        end: {
          line: 4,
          column: 95
        }
      },
      "2": {
        start: {
          line: 11,
          column: 23
        },
        end: {
          line: 37,
          column: 1
        }
      },
      "3": {
        start: {
          line: 11,
          column: 46
        },
        end: {
          line: 37,
          column: 1
        }
      },
      "4": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 17
        }
      },
      "5": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 17,
          column: 5
        }
      },
      "6": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 65
        }
      },
      "7": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 63
        }
      },
      "8": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 66
        }
      },
      "9": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 47
        }
      },
      "10": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 79
        }
      },
      "11": {
        start: {
          line: 39,
          column: 34
        },
        end: {
          line: 42,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 22
          },
          end: {
            line: 4,
            column: 23
          }
        },
        loc: {
          start: {
            line: 4,
            column: 29
          },
          end: {
            line: 4,
            column: 95
          }
        },
        line: 4
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 23
          },
          end: {
            line: 11,
            column: 24
          }
        },
        loc: {
          start: {
            line: 11,
            column: 46
          },
          end: {
            line: 37,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 12,
            column: 21
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 12
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 22
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 22
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        loc: {
          start: {
            line: 26,
            column: 25
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 26
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 30,
            column: 2
          },
          end: {
            line: 30,
            column: 3
          }
        },
        loc: {
          start: {
            line: 30,
            column: 23
          },
          end: {
            line: 32,
            column: 3
          }
        },
        line: 30
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 34,
            column: 3
          }
        },
        loc: {
          start: {
            line: 34,
            column: 11
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 34
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 4,
            column: 38
          },
          end: {
            line: 4,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 4,
            column: 38
          },
          end: {
            line: 4,
            column: 55
          }
        }, {
          start: {
            line: 4,
            column: 59
          },
          end: {
            line: 4,
            column: 60
          }
        }],
        line: 4
      },
      "1": {
        loc: {
          start: {
            line: 4,
            column: 70
          },
          end: {
            line: 4,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 4,
            column: 70
          },
          end: {
            line: 4,
            column: 88
          }
        }, {
          start: {
            line: 4,
            column: 92
          },
          end: {
            line: 4,
            column: 93
          }
        }],
        line: 4
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0219a77160bca23d0d481e8be704d55efe0dac1e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_6vtzfnhiq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_6vtzfnhiq();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
cov_6vtzfnhiq().s[0]++;
var getWindowSize = function getWindowSize() {
  cov_6vtzfnhiq().f[0]++;
  cov_6vtzfnhiq().s[1]++;
  return {
    width: (cov_6vtzfnhiq().b[0][0]++, window.innerWidth) || (cov_6vtzfnhiq().b[0][1]++, 0),
    height: (cov_6vtzfnhiq().b[1][0]++, window.innerHeight) || (cov_6vtzfnhiq().b[1][1]++, 0)
  };
};

/**
 * Enhances a component with window size information.
 * @param {React.Component} EnhancedComponent - The component to enhance.
 * @returns {React.Component} Enhanced component with window size information.
 */
cov_6vtzfnhiq().s[2]++;
var withWindowSize = function withWindowSize(EnhancedComponent) {
  cov_6vtzfnhiq().f[1]++;
  cov_6vtzfnhiq().s[3]++;
  return /*#__PURE__*/function (_React$Component) {
    function WithWindowSize(props) {
      var _this;
      (0, _classCallCheck2.default)(this, WithWindowSize);
      cov_6vtzfnhiq().f[2]++;
      cov_6vtzfnhiq().s[4]++;
      _this = _callSuper(this, WithWindowSize, [props]);
      cov_6vtzfnhiq().s[5]++;
      _this.state = {
        window: getWindowSize()
      };
      cov_6vtzfnhiq().s[6]++;
      _this.handleWindowResize = _this.handleWindowResize.bind(_this);
      return _this;
    }
    (0, _inherits2.default)(WithWindowSize, _React$Component);
    return (0, _createClass2.default)(WithWindowSize, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        cov_6vtzfnhiq().f[3]++;
        cov_6vtzfnhiq().s[7]++;
        window.addEventListener('resize', this.handleWindowResize);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        cov_6vtzfnhiq().f[4]++;
        cov_6vtzfnhiq().s[8]++;
        window.removeEventListener('resize', this.handleWindowResize);
      }
    }, {
      key: "handleWindowResize",
      value: function handleWindowResize() {
        cov_6vtzfnhiq().f[5]++;
        cov_6vtzfnhiq().s[9]++;
        this.setState({
          window: getWindowSize()
        });
      }
    }, {
      key: "render",
      value: function render() {
        cov_6vtzfnhiq().f[6]++;
        cov_6vtzfnhiq().s[10]++;
        return /*#__PURE__*/_react.default.createElement(EnhancedComponent, (0, _extends2.default)({}, this.props, {
          windowSize: this.state.window,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 35,
            columnNumber: 12
          }
        }));
      }
    }]);
  }(_react.default.Component);
};
var WithWindowSizeType = exports.WithWindowSizeType = (cov_6vtzfnhiq().s[11]++, _propTypes.default.shape({
  width: _propTypes.default.number,
  height: _propTypes.default.number
}));
var _default = exports.default = withWindowSize;